import Vue from 'vue'
import {UPDATE_VOUCHER, SET_VOUCHER, RESET_VOUCHERS, SET_VOUCHERS} from './mutationTypes'
import VouchersApi from '@/api/vouchers'

export default {
  namespaced: true,
  state: {
    vouchersMap: {}
  },
  mutations: {
    [UPDATE_VOUCHER](state, voucher) {
      if (state.vouchersMap[voucher._id]) {
        state.vouchersMap[voucher._id] = voucher
      } else {
        Vue.set(state.vouchersMap, voucher._id, voucher)
      }
    },
    [SET_VOUCHERS](state, vouchers) {
      vouchers.forEach(voucher => {
        Vue.set(state.vouchersMap, voucher._id, voucher)
      })
    },
    [SET_VOUCHER](state, voucher) {
      Vue.set(state.vouchersMap, voucher._id, voucher)
    },

    [RESET_VOUCHERS](state) {
      state.vouchersMap = {}
    }
  },
  actions: {
    async updateVoucher({commit}, {id, data}) {
      const voucher = await VouchersApi.updateVoucher(id, data)
      commit(UPDATE_VOUCHER, voucher)
      return voucher
    },
    async getVoucherById({commit, state}, {voucherId, force}) {
      if (!state.vouchersMap[voucherId] || force) {
        const voucher = await VouchersApi.getVoucherById(voucherId)
        commit(SET_VOUCHER, voucher)
      }
      return state.vouchersMap[voucherId]
    },
    async searchVouchers({commit}, query) {
      if (!query || !query.trim().length) {
        return {data: [], total: 0}
      }
      const {data, total} = await VouchersApi.search({
        code: query.trim(),
        perPage: 100
      })
      commit(SET_VOUCHERS, data)
      return {data, total}
    },
    reset({commit}) {
      commit(RESET_VOUCHERS)
    }
  }
}
